"use client"

import { useEffect, useState } from "react"
import { PulseDot } from "@/components/ui/pulse-dot"

// Client-side "Next Availability" pill for a barber's booking profile. Scans
// ahead via /api/appointments/next-available and shows the next bookable slot
// ("Next available Wed 9:00 AM"). Renders nothing until it resolves / if none.
export function NextAvailabilityBadge({ barberId, durationMin = 30 }: { barberId: string; durationMin?: number }) {
  const [label, setLabel] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    fetch(`/api/appointments/next-available?barber=${barberId}&duration=${durationMin}`)
      .then((r) => r.json())
      .then((j) => {
        if (cancelled) return
        const n = j?.next
        if (!n) return setLabel(null)
        const time = String(n.label).replace(/^0/, "")
        setLabel(n.isToday ? `Next: ${time}` : `Next: ${n.dayLabel} ${time}`)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [barberId, durationMin])

  if (!label) return null
  // One pill language on both grounds: barely-there translucent tint with a
  // hairline stroke, brand-green lozenge, neutral text (black on light,
  // white on dark). No more electric-yellow dark variant.
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 bg-black/[0.04] border-[0.4px] border-black/30 shadow-none dark:bg-white/[0.03] dark:border-white/25">
      {/* Lozenge indicator (shared PulseDot): brand green everywhere. */}
      <PulseDot color="#10b981" />
      <span className="text-[11px] font-normal whitespace-nowrap text-neutral-600 dark:text-neutral-300">{label}</span>
    </div>
  )
}
